module.exports = __webpack_public_path__ + "static/img/solutionText13.2d95193.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionText13.png
// module id = vni3
// module chunks = 1